var AbstractWS = require("./AbstractWS");

function UpdateConsumerNameAndNotesWS(queueId) {
    var self;
  
    // Predicate this Web Service handler on the Abstract class of a Web
    // Service handler. This establishes core functionality required of
    // these such handlers, which can be overwritten by methods below.
    AbstractWS.apply(this, arguments);
  
    self = this;
    self.method('POST');
    self.name = 'UpdateConsumerNameAndNotesWS';

  
    /**
     * Defines the string to request API services
     *
     * @method serviceURL
     * @returns {String}
     */
    self.serviceURL = function () {
      return '/qless/api/v1/employee/queue/'+ queueId +'/consumer'
    };
  
    return self;
  };
  
  UpdateConsumerNameAndNotesWS.prototype = Object.create(AbstractWS.prototype);
  UpdateConsumerNameAndNotesWS.prototype.constructor = UpdateConsumerNameAndNotesWS;
  
  
module.exports = UpdateConsumerNameAndNotesWS;
